export const anchorInit = () => {
    const containerMain = document.querySelector('.js-check-anchors');
    if (containerMain) {
        const allTitles = containerMain.querySelectorAll('.js-anchor-link');
        const arrayTitles = [];
        allTitles &&
            allTitles.forEach((item, index) => {
                if (item instanceof HTMLElement) {
                    const key = `anchor-key-${index}`;
                    item.setAttribute('id', key);
                    arrayTitles.push({
                        name: item.innerText,
                        id: key,
                    });
                }
            });
        const containerLinks = containerMain.querySelector('.js-anchor-list');
        if (!containerLinks) {
            return;
        }
        const linkList = containerLinks.querySelector('.js-anchor-list-items');
        if (!linkList)
            return;
        if (arrayTitles.length === 0) {
            containerLinks.classList.add('hidden');
            return;
        }
        let templates = '';
        arrayTitles &&
            arrayTitles.forEach((item) => {
                console.log(item);
                templates += `<a href="#${item === null || item === void 0 ? void 0 : item.id}" class="anchor-link js-anchor-trigger">
                                ${item === null || item === void 0 ? void 0 : item.name}
                              </a>`;
            });
        linkList.innerHTML = templates;
        const anchorLinks = containerLinks.querySelectorAll('.js-anchor-trigger');
        anchorLinks &&
            anchorLinks.forEach(function (link) {
                link.addEventListener('click', function (event) {
                    event.preventDefault();
                    const target = event.target;
                    const targetId = target.getAttribute('href');
                    if (!targetId)
                        return;
                    const targetElement = document.querySelector(targetId);
                    if (targetElement instanceof HTMLElement) {
                        console.log('targetElement', targetElement.offsetTop);
                        const targetRect = targetElement.getBoundingClientRect();
                        const targetOffset = window.scrollY + targetRect.top - 100;
                        window.scrollTo({
                            top: targetOffset,
                            behavior: 'smooth',
                        });
                    }
                });
            });
        containerLinks.classList.remove('hidden');
        const containerLinksHeight = containerLinks.offsetHeight;
        containerLinks.classList.add('hidden');
        window.addEventListener('scroll', function () {
            anchorLinks.forEach(function (link) {
                const targetId = link.getAttribute('href');
                if (!targetId)
                    return;
                const targetElement = document.querySelector(targetId);
                if (!targetElement)
                    return;
                if (targetElement.getBoundingClientRect().top <= window.innerHeight / 3) {
                    anchorLinks.forEach(function (link) {
                        link.classList.remove('active');
                    });
                    link.classList.add('active');
                }
            });
            if (containerMain.getBoundingClientRect().top <= window.innerHeight / 5 &&
                containerMain.getBoundingClientRect().bottom - (containerLinksHeight + 100) >= 0) {
                containerLinks.classList.remove('hidden');
            }
            else {
                containerLinks.classList.add('hidden');
            }
        });
    }
};
